import React, { useEffect }  from 'react'
import {BiMoon, BiSun} from "react-icons/bi"
import Fotter from './Fotter';




function Navbar(props) {
  useEffect( ( ) =>{
    const navbar = document.body.querySelector(".navbar");

    navbar.style.backgroundColor =" white";
  },[])

  let mode = props.mode;
  let setMode = props.setMode;
  function handler()
  {
    const Mode = document.body;
    const navbar = document.body.querySelector(".navbar");
      const bg1 = document.body.querySelector(".fotter");
       
      
  
    
    if(mode === true){

      setMode(false);
      Mode.classList.remove("bright-mode");
      Mode.classList.add("dark-mode");
      navbar.style.backgroundColor = "#191627";
      bg1.style.backgroundColor = " rgb(1 2 20)";
      
    }
    else{
      setMode(true);
      Mode.classList.remove("dark-mode");
      Mode.classList.add("bright-mode");
      navbar.style.backgroundColor =" white";
      bg1.style.backgroundColor = "#6E57E0";
    }
   
  }

  
  return (
    <div className="md:flex flex-row hidden justify-around  mx-auto items-center font-Poppins sticky top-0 h-[4rem] z-[100] border-10 border-black bg-back navbar  ">
      <div className=" hover:text-deep">
        <a href="#">Tanmay | Web Developer</a>
      </div>

      <div>
        <ul className=" md:flex hiddden space-x-6 ">
          <li className=" hover:text-deep">
            <a href="#">Home</a>
          </li>
          <li className="  hover:text-deep">
            <a href="#About">About</a>
          </li>
          <li className=" hover:text-deep">
            <a href="#Skill">Skills</a>
          </li>

          <li className=" hover:text-deep">
            <a href="#Projects">Projects</a>
          </li>
          <li className=" hover:text-deep">
            <a href="#ContactMe">ContactMe</a>
          </li>
          <li className=" mt-0.5 hover:cursor-pointer hover:text-deep font-bold ">
            {mode ? (
              <span onClick={handler}>
                {" "}
                <BiMoon fontSize={20} />
              </span>
            ) : (
              <span onClick={handler}>
                {" "}
                <BiSun fontSize={20} />
              </span>
            )}
          </li>
        </ul>
        
      </div>
    </div>
  );
}

export default Navbar